import { ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const systemDashboardEditRoute: InvariantRoute = {
	name: ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT,
	path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
	query: ['maximized?'],
};
